import type { SVGProps } from "react";
export interface MotorbikeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MotorbikeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MotorbikeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.027 2.875c1.3 0 2.454.804 2.915 2H18l.116.005a1.126 1.126 0 0 1 0 2.239L18 7.125h-.395l.522 1.806a7.1 7.1 0 0 1 2.966.258l.282.092.107.044a1.125 1.125 0 0 1-.747 2.11l-.497-.152a4.9 4.9 0 0 0-1.475-.15l1.317 4.555.026.111a1.125 1.125 0 0 1-2.149.623l-.038-.11-1.318-4.557a4.88 4.88 0 0 0-2.46 3.838 1.125 1.125 0 0 1-1.12 1.032h-3.02a1.125 1.125 0 0 1 0-2.25h2.062a7.14 7.14 0 0 1 3.902-4.822l-1.098-3.797a.875.875 0 0 0-.84-.631h-1.026a1.125 1.125 0 0 1 0-2.25zm-4.026 4 .114.006a1.126 1.126 0 0 1 0 2.239L10 9.125H6a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M10 9.875c.62 0 1.124.504 1.124 1.125v4.5c0 .597-.464 1.083-1.051 1.12a4.12 4.12 0 0 1-8.158-.079 1.53 1.53 0 0 1-1.04-1.45 5.217 5.217 0 0 1 5.216-5.216zm10.875 6.124a1.875 1.875 0 1 0-3.751.001 1.875 1.875 0 0 0 3.75 0Zm-16.641.626a1.874 1.874 0 0 0 3.532 0zm1.857-4.5c-1.39 0-2.555.958-2.875 2.25h5.659v-2.25H6.09Zm17.034 3.874a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      />
    </svg>
  );
}
